////////GHG EF 3.1 schema
const threeOneSchema = {
  title: "3.1 Purchased Goods and Services",
  cat: "4_1",
  catName: "cat4",
  progressiveOrderSwitch: {
    by: { level: 3, key: "computationMethod" },
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
      specialDataShouldIf: {
        level: 1,
        key: "categoryISO64",
        notEmpty: true,
        formData: "EAFormData",
      },
    },
    //////////////// 如果選擇4_1
    ////////Data Source
    {
      key: "emissionFactorTypeId",
      level: 2,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      specialDataShouldIf: {
        level: 1,
        key: "categoryISO64",
        eq: "4_1",
        formData: "EAFormData",
      },
      autoFillNum: 0,
    },
    ////////Computation Method
    {
      key: "computationMethod",
      level: 3,
      type: "select",
      label: "Computation Method",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        value: "4_1",
      },
      showIf: { level: 2, key: "emissionFactorTypeId", ne: "2" },
      specialDataShouldIf: {
        level: 1,
        key: "categoryISO64",
        eq: "4_1",
        formData: "EAFormData",
      },
      combineKey: 1,
    },
    ////////Emission Factor Database Source
    {
      key: "sourceEFName",
      level: 4,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "computationMethod",
      },
      showIf: { level: 3, key: "computationMethod", notEmpty: true },
      specialDataShouldIf: {
        level: 1,
        key: "categoryISO64",
        eq: "4_1",
        formData: "EAFormData",
      },
      combineKey: 2,
    },
    //////// Material / Product / Asset Type
    {
      key: "assetType",
      level: 5,
      type: "select",
      label: "Material / Product / Asset Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "sourceEFName",
      },
      showIf: { level: 4, key: "sourceEFName", notEmpty: true },
      specialDataShouldIf: {
        level: 1,
        key: "categoryISO64",
        eq: "4_1",
        formData: "EAFormData",
      },
      combineKey: 3,
    },
    ////////Emission Factor Name (非自定義)
    {
      key: "emissionFactorId",
      level: 6,
      type: "select",
      label: "Material / Product / Asset Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "assetType",
      },
      showIf: {
        level: 5,
        key: "assetType",
        notEmpty: true,
      },
      specialDataShouldIf: {
        level: 1,
        key: "categoryISO64",
        eq: "4_1",
        formData: "EAFormData",
      },
      combineKey: 4,
    },
    ////////Emission Factor Name (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 6,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat4CustomEFDropdownList",
      showIf: {
        level: 2,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      specialDataShouldIf: {
        level: 1,
        key: "categoryISO64",
        eq: "4_1",
        formData: "EAFormData",
      },
      autoFillNum: 0,
    },
    //////////////// 如果選擇4_5
    ////////Data Source
    {
      key: "emissionFactorTypeId",
      level: 2,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
      specialDataShouldIf: {
        level: 1,
        key: "categoryISO64",
        eq: "4_5",
        formData: "EAFormData",
      },
    },
    ////////Computation Method
    {
      key: "computationMethod",
      level: 3,
      type: "select",
      label: "Computation Method",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        value: "4_5",
      },
      showIf: { level: 2, key: "emissionFactorTypeId", ne: "2" },
      specialDataShouldIf: {
        level: 1,
        key: "categoryISO64",
        eq: "4_5",
        formData: "EAFormData",
      },
      combineKey: 1,
    },
    ////////Emission Factor Database Source
    {
      key: "sourceEFName",
      level: 4,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "computationMethod",
      },
      showIf: { level: 3, key: "computationMethod", notEmpty: true },
      specialDataShouldIf: {
        level: 1,
        key: "categoryISO64",
        eq: "4_5",
        formData: "EAFormData",
      },
      combineKey: 2,
    },
    //////// Material / Product / Asset Type
    {
      key: "assetType",
      level: 5,
      type: "select",
      label: "Material / Product / Asset Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "sourceEFName",
      },
      showIf: { level: 4, key: "sourceEFName", notEmpty: true },
      specialDataShouldIf: {
        level: 1,
        key: "categoryISO64",
        eq: "4_5",
        formData: "EAFormData",
      },
      combineKey: 3,
    },
    ////////Emission Factor Name (非自定義)
    {
      key: "emissionFactorId",
      level: 6,
      type: "select",
      label: "Material / Product / Asset Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "assetType",
      },
      showIf: {
        level: 5,
        key: "assetType",
        notEmpty: true,
      },
      specialDataShouldIf: {
        level: 1,
        key: "categoryISO64",
        eq: "4_5",
        formData: "EAFormData",
      },
      combineKey: 4,
    },
    ////////Emission Factor Name (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 6,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat4CustomEFDropdownList",
      showIf: {
        level: 2,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      specialDataShouldIf: {
        level: 1,
        key: "categoryISO64",
        eq: "4_5",
        formData: "EAFormData",
      },
      autoFillNum: 0,
    },
  ],
};

export default threeOneSchema;
